import { render } from "./TestDrap.vue?vue&type=template&id=659018ec"
import script from "./TestDrap.vue?vue&type=script&lang=js"
export * from "./TestDrap.vue?vue&type=script&lang=js"
script.render = render

export default script